import React from 'react';

const Reports = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h1>Reportes</h1>
      <p>Sección de reportes en desarrollo...</p>
      <div style={{ 
        background: '#f8fafb', 
        border: '1px solid #e2e8f0', 
        borderRadius: '8px', 
        padding: '20px', 
        marginTop: '20px' 
      }}>
        <h3>Próximamente:</h3>
        <ul>
          <li>Reportes Financieros</li>
          <li>Reportes de Pacientes</li>
          <li>Reportes de Citas</li>
        </ul>
      </div>
    </div>
  );
};

export default Reports;
